<template>
  <div v-if="isAndroid" class="bg-white h-full">
    <!-- Header -->
    <div class="flex items-center justify-between p-4" v-if="datalists.type == 1 || datalists.type == null">
      <div class="flex items-center gap-2">
        <img src="/topgoge.png" alt="" class="w-8 h-8" />
        <span class="text-gray-700 font-medium text-lg">Google Play</span>
        <img src="/GooglePlay-right.png" alt="" class="w-23 h-8 ml-25" />
      </div>
    </div>

    <!-- App Header -->
    <div class="p-4 mt-5 px-6">
      <div class="flex items-start gap-4">
        <img :src="ICON_BASE_URL + datalists.icon" alt="" class="w-18 h-18 object-cover rounded-lg" />
        <div class="flex-1">
          <div class="text-xl font-bold text-gray-900">{{ datalists.name }}</div>
          <div class="text-xl text-green-600 font-medium">{{ datalists.domainName }}</div>
          <div class="text-xs font-medium" style="color: #6F7276;">Verified by the app</div>
        </div>
      </div>

      <div class="flex items-center justify-between mt-6 text-sm text-gray-600 ml-4">
        <div class="flex flex-col items-center">
          <div class="flex items-center">
            <span class="font-bold text-gray-900">{{ datalists.score }}</span>
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
          </div>
          <div class="text-xs text-gray-500 mt-0.5">8M reviews</div>
        </div>

        <div class="flex flex-col items-center">
          <div class="flex items-center">100M +</div>
          <div class="text-xs text-gray-500 mt-0.5">Downloading</div>
        </div>

        <div class="flex flex-col items-center">
          <div class="flex items-center">
            <div class="flex items-center mr-3" v-if="datalists.type == 1 || datalists.type == null">100M+</div>
            <div class="flex items-center mr-3" v-if="datalists.type == 2">
              <img src="@/assets/download/favicon-BklneJme.png" alt="" class="w-3 h-3 ml-1">
            </div>
          </div>
          <div class="flex items-center mt-0.5">
            <span class="text-xs text-gray-500">Rated for 18+</span>
          </div>
        </div>
      </div>

      <!-- Install Button -->
      <div class="w-full mt-6 btn-color text-white font-medium py-2 rounded-lg transition-colors hover:bg-green-700"
        @click="handleShow" v-if="datalists.type == 1 || datalists.type == null">
        <div class="text-center" style="color: #F9E444;">
          <img class="w-3 h-4 inline-block" src="/lightning.png" alt="">
          <span>Quick Installation</span>
        </div>
        <div class="text-center">
          <span>Download within 15 seconds</span>
        </div>
      </div>
      <div @click="handleShow" v-if="datalists.type == 2"
        class="w-full mt-6 font-medium py-2 rounded-lg transition-colors bg-[#0070C9] color-[#fff] text-center text-[14px] flex items-center justify-center cursor-pointer">
        <div>Get the app on the App Store</div>
        <img src="@/assets/download/zu1.png" alt="" class="w-3 h-3 ml-1">
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center justify-center gap-6 mt-3 text-sm text-gray-600">

        <div class="flex items-center gap-1.5  transition-colors">
          <img src="/share.png" alt="" class="w-4 h-4" />
          <span class="text-green-600 font-bold text-sm">To Share</span>
        </div>


        <div class="flex items-center gap-1.5 transition-colors">
          <img src="/add.png" alt="" class="w-3 h-4" />
          <span class="text-green-600 text-sm">Add to wishlist</span>
        </div>
      </div>
    </div>
    <!-- imgAction -->
    <div class="flex items-center justify-center overflow-x-auto">
      <div class="flex items-center gap-4 px-4">
        <img v-for="item in datalists.promotionalPicture" :key="item" :src="ICON_BASE_URL + item" alt=""
          class="w-35 h-70 flex-shrink-0 object-cover rounded-lg" />
      </div>
    </div>


    <!-- About Section -->
    <div class="px-4 py-4">
      <h2 class="flex font-bold text-gray-900 text-lg">
        About this app
        <img src="/向右.png" alt="" class="w-5 h-5 ml-49" v-if="datalists.type == 1 || datalists.type == null">
      </h2>

      <div class="max-w-full break-words whitespace-normal">{{ datalists.introduction }}</div>


      <div class="text-sm text-gray-600 leading-relaxed mt-2">
        <strong>Updated on</strong>
        <div>March 27, 2024</div>
      </div>

      <div class="flex gap-2 mt-4 flex-wrap">
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full mr-8">#1 Most Popular Free Action
          App</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full">Action</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-9 py-1 rounded-full mr-8">Platform games</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full mr-16">Casual</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-6 py-1 rounded-full mr-2">Multiplayer</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-5 py-1 rounded-full">Stylized</span>
      </div>
    </div>

    <!-- Data Safety -->
    <div class="px-4 py-4 border-t">
      <div class="flex items-center gap-2 mb-2">
        <div class="font-bold text-gray-900 text-lg">
          Data security
          <img src="/向右.png" alt="" class="w-5 h-5 ml-51">

        </div>
      </div>
      <p class="text-sm text-gray-600 leading-relaxed">
        Your security starts with understanding how<br></br>
        developers collect and share your data.<br></br>
        Data security and privacy practices may vary based on <br></br>
        your use, region, and age.<br></br>
        The developer has provided the following information, <br></br>
        which may be updated over time.
      </p>

      <div class="mt-4 space-y-3 border border-gray-200 rounded-lg p-3">
        <div v-for="safety in dataSafetyItems" :key="safety.text" class="flex items-center gap-3 ">
          <img :src="safety.icon" alt="" class="w-4 h-5" />
          <div class="text-sm text-gray-700">{{ safety.text }}</div>
        </div>
      </div>
    </div>

    <!-- Ratings and Reviews -->
    <div class="px-4 py-4 border-t">
      <div class="flex items-center justify-between mb-4">
        <div class="font-bold text-gray-900 text-lg">Ratings and Reviews</div>
        <i data-lucide="chevron-right" class="w-4 h-4 text-gray-400"></i>
      </div>

      <p class="text-sm text-gray-600 mb-4">
        The ratings and reviews are verified and come from people who use the same type of device as you: Phone
      </p>

      <div class="flex mb-14 mt-14">
        <el-tag size="small" type="info" effect="plain" class="clickable-tag w-30 flex justify-center text-md"
          @click="handleTagClick" style="background-color: #dde9e6; color: #01875f; border-radius: 50px">
          <img src="/icon-phone.png" alt="" class="mr-1">Telephone
        </el-tag>
        <el-tag size="small" type="info" effect="plain" class="w-30 flex justify-center text-md">
          <img src="/icon-tablet.png" alt="" class="mr-1">Tablet
        </el-tag>
        <br></br>
        <el-tag size="small" type="info" effect="plain" class="w-30 flex justify-center text-md">
          <img src="/icon-crbook.png" alt="" class="mr-1">Chromebook
        </el-tag>
      </div>

      <div class="flex items-center gap-4 mb-6">
        <div class="text-center">
          <div class="text-4xl font-light text-gray-900 text-left">{{ datalists.score }}</div>
          <div>
            <img src="/多边形 15.png" alt="" class="w-3 h-3">
            <img src="/多边形 15.png" alt="" class="w-3 h-3">
            <img src="/多边形 15.png" alt="" class="w-3 h-3">
            <img src="/多边形 15.png" alt="" class="w-3 h-3">
            <img src="@/assets/download/zu1.png" alt="" class="w-3 h-3">
          </div>
          <div class="text-gray-400 text-sm pr-5">50000</div>
          <div class="flex justify-center mt-1">
            <el-rate v-model="overallRating" disabled size="small" :colors="['#22c55e', '#22c55e', '#22c55e']"
              class="rating-small" />
          </div>
        </div>
        <div class="flex-1 space-y-1">
          <div v-for="rating in ratingDistribution" :key="rating.stars" class="flex items-center gap-2">
            <span class="text-xs text-gray-600 w-2">{{ rating.stars }}</span>
            <div class="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-full bg-green-500 rounded-full transition-all duration-300"
                :style="{ width: rating.percentage }"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reviews -->
      <div class="space-y-4">
        <div v-for="(review, index) in reviews" :key="index" class="border-b border-gray-100 pb-4 last:border-b-0">
          <div class="flex items-center gap-2 mb-2 justify-between">
            <el-avatar :size="32" class="flex w-full">
              <img :src="review.avatar" alt="">
              <span class="text-sm font-medium text-gray-900 mt-2.5 ml-3">{{ review.name }}</span>
            </el-avatar>

            <img class="w-1" src="/组 1053.png" alt="">
          </div>
          <div class="flex items-center gap-2 mb-2">
            <el-rate v-model="review.rating" disabled size="small" :colors="['#22c55e', '#22c55e', '#22c55e']"
              class="rating-small" />
            <span class="text-xs text-gray-500">
              <img src="/多边形 15.png" alt="" class="w-3 h-3">
              <img src="/多边形 15.png" alt="" class="w-3 h-3">
              <img src="/多边形 15.png" alt="" class="w-3 h-3">
              <img src="/多边形 15.png" alt="" class="w-3 h-3">
              <img src="/多边形 15.png" alt="" class="w-3 h-3">
              <span class="ml-2">month.01 02, 2025</span>
            </span>
          </div>
          <p class="text-sm text-gray-700 leading-relaxed">{{ review.text }}</p>
          <!-- <div class="flex items-center gap-4 mt-2 text-xs text-gray-500">
            <span>{{ review.helpful }} people found this review useful</span>
          </div>
          <div class="flex items-center gap-2 mt-2">
            <span class="text-xs text-gray-600">Did you find it useful?</span>
            <el-button size="small" plain>Yes</el-button>
            <el-button size="small" plain>No</el-button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div v-if="datalists.type == 1 || datalists.type == null">
      <div class="px-4 py-6 border-t bg-gray-50 text-xs text-gray-600 space-y-2">
        <p class="font-medium">Google Play</p>
        <div class=" grid-cols-2">
          <p v-for="link in footerLinks" :key="link">{{ link }}</p>
        </div>
        <div class="border-t border-gray-200 pt-4 mt-4 space-y-2 grid grid-cols-3">
          <p class="w-23" v-for="link in footerLink" :key="link">{{ link }}</p>

        </div>
      </div>
      <div class="flex justify-around mt-4">
        <div class="w-25 h-12" v-for="link in TabGanmes" :key="link">
          <img class="h-5 ml-6.5" :src="link.icon" alt="">
          <div class="text-sm text-center text-gray-500">{{ link.name }}</div>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <!-- <el-dialog v-model="showImageModal" :show-close="false" :modal="true" :close-on-click-modal="true"
      :close-on-press-escape="true" width="90%" top="5vh" class="image-modal">
      <template #header>
        <div class="flex justify-between items-center">
          <span class="text-white">Screenshot {{ selectedImageIndex + 1 }} of {{ screenshots.length }}</span>
          <el-button @click="closeImageModal" type="primary" circle size="small">
            <i data-lucide="x" class="w-4 h-4"></i>
          </el-button>
        </div>
      </template>

<div class="text-center">
  <div class="w-full h-96 rounded-lg overflow-hidden mx-auto max-w-sm" :style="{ background: selectedImage?.gradient }">
  </div>
  <div class="flex justify-center mt-4 gap-2">
    <el-button v-for="(screenshot, index) in screenshots" :key="index" @click="selectImage(index)"
      :type="selectedImageIndex === index ? 'primary' : 'default'" circle size="small" class="w-3 h-3 min-w-0 p-0" />
  </div>
</div>
</el-dialog> -->
  </div>
  <div v-else class="bg-white pt-1">
    <!-- App Header -->
    <div class="p-4 mt-5 px-6">
      <div class="flex items-start gap-4">
        <img src="/pwa192x192.png" alt="" class="w-18 h-18 object-cover rounded-lg" />
        <div class="flex-1">
          <div class="text-xl font-bold text-gray-900">Suer Win Ph <br></br>Game App Official</div>
          <!-- <div class="text-xl text-green-600 font-medium"></div> -->
          <div class="text-xs font-medium " style="color: #6F7276;">BLUE WHAL<br></br> Verificado pelo aplicativo</div>
        </div>
      </div>

      <div class="flex items-center justify-between mt-6 text-sm text-gray-600 ml-4">
        <div class="flex flex-col items-center">
          <div class="flex items-center">
            <span class="font-bold text-gray-900">{{ datalists.score }}</span>
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
            <img src="/rating.png" alt="" class="w-3 h-3 ml-1" />
          </div>
          <div class="text-xs text-gray-500 mt-0.5">8M reviews</div>
        </div>

        <div class="flex flex-col items-center">
          <div class="flex items-center">500K+</div>
          <div class="text-xs text-gray-500 mt-0.5">Downloading</div>
        </div>

        <div class="flex flex-col items-center">
          <div class="flex items-center">

            <img src="@/assets/download/favicon-BklneJme.png" alt="" class="w-2.5 h-2.5 ml-1" />

          </div>
          <div class="flex items-center mt-0.5">
            <span class="text-xs text-gray-500">For ages 18+</span>
          </div>
        </div>
      </div>

      <!-- Install Button -->
      <div class="w-full mt-6 bg-blue-600 text-white font-medium py-2 rounded-lg transition-colors hover:bg-green-700"
        @click="handleShow">
        <div class="text-center" style="color: white;">
          Get the app on the App Store
          <img class="w-3 h-4 inline-block" src="@/assets/download/zu1.png" alt="">

        </div>

      </div>

      <!-- Action Buttons -->
      <!-- <div class="flex items-center justify-center gap-6 mt-3 text-sm text-gray-600">

          <div class="flex items-center gap-1.5  transition-colors">
            <img src="/share.png" alt="" class="w-4 h-4" />
          <span class="text-green-600 font-bold text-sm">To Share</span>
          </div>


            <div class="flex items-center gap-1.5 transition-colors">
                <img src="/add.png" alt="" class="w-3 h-4" />
                <span class="text-green-600 text-sm">Add to wishlist</span>
            </div>
      </div> -->
    </div>
    <!-- imgAction -->
    <div class="flex items-center justify-center mt-4">
      <img src="/1.png" alt="" class="w-35 h-70" />
      <img src="/2.png" alt="" class="w-35 h-70" />
      <img src="/3.png" alt="" class="w-15 h-70" />
    </div>


    <!-- About Section -->
    <div class="px-4 py-4">
      <h2 class="flex font-bold text-gray-900 text-lg">
        About this app
      </h2>
      <div>
        <div class="max-w-full break-words whitespace-normal">{{ datalists.introduction }}</div>
      </div>
      <!-- <p class="text-sm text-gray-600 leading-relaxed mt-2">
            Invite a friend and earn {{ VITE_symbol }}50<br></br>
                5% commission<br>
                Day 2-3-7-15-30<br>
                Mysterious bonus for new members: {{ VITE_symbol }}8,888<br>
                Daily login — Max prize {{ VITE_symbol }}200<br>
                Exclusive agent<br>
                Earn up to {{ VITE_symbol }}1,000,000 per month easily<br>
                Upgrade to VIP — Promotional bonus up to<br>
                {{ VITE_symbol }}999,999<br>
                Per week / Per month<br>
                {{ VITE_symbol }}30,000 + {{ VITE_symbol }}100,000<br>
                Final earnings are not guaranteed
      </p> -->


      <div class="text-sm text-gray-600 leading-relaxed mt-2">
        <strong>Updated on</strong>
        <div>March 27, 2024</div>
      </div>

      <div class="flex gap-2 mt-4 flex-wrap">
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full mr-8">#1 Most Popular Free Action
          App</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full">Action</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-9 py-1 rounded-full mr-8">Platform games</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-3 py-1 rounded-full mr-16">Casual</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-6 py-1 rounded-full mr-2">Multiplayer</span>
        <span class="bg-gray-100 text-gray-700 text-xs px-5 py-1 rounded-full">Stylized</span>
      </div>
    </div>

    <!-- Data Safety -->
    <div class="px-4 py-4 border-t">
      <div class="flex items-center gap-2 mb-2">
        <div class="font-bold text-gray-900 text-lg">
          Data security
          <img src="/向右.png" alt="" class="w-5 h-5 ml-51">

        </div>
      </div>
      <p class="text-sm text-gray-600 leading-relaxed">
        Your security starts with understanding how<br></br>
        developers collect and share your data.<br></br>
        Data security and privacy practices may vary based on <br></br>
        your use, region, and age.<br></br>
        The developer has provided the following information, <br></br>
        which may be updated over time.
      </p>

      <div class="mt-4 space-y-3 border border-gray-200 rounded-lg p-3">
        <div v-for="safety in dataSafetyItems" :key="safety.text" class="flex items-center gap-3 ">
          <img :src="safety.icon" alt="" class="w-5 h-5" />
          <div class="text-sm text-gray-700">{{ safety.text }}</div>
        </div>
      </div>
    </div>

    <!-- Ratings and Reviews -->
    <div class="px-4 py-4 border-t">
      <div class="flex items-center justify-between mb-4">
        <div class=" text-gray-900 text-lg flex">
          Ratings and Reviews
          <img src="/向右.png" alt="" class="w-5 h-5 ml-38">
        </div>
        <!-- <i data-lucide="chevron-right" class="w-4 h-4 text-gray-400"></i> -->
      </div>

      <p class="text-sm text-gray-600 mb-4">
        The ratings and reviews are verified and come from people who use the same type of device as you: Phone
      </p>

      <div class="flex mb-14 mt-14">
        <el-tag size="small" type="info" effect="plain" class="clickable-tag w-30 flex justify-center text-md"
          @click="handleTagClick" style="background-color: #dde9e6; color: #01875f; border-radius: 50px">
          <img src="/icon-phone.png" alt="" class="mr-1">Telephone
        </el-tag>
        <el-tag size="small" type="info" effect="plain" class="w-30 flex justify-center text-md">
          <img src="/icon-tablet.png" alt="" class="mr-1">Tablet
        </el-tag>
      </div>

      <div class="flex items-center gap-4 mb-6">
        <div class="text-center">
          <div class="text-6xl font-light text-gray-900 text-left">{{ datalists.score }}</div>
          <div>
            <img src="/多边形 1.png" alt="" class="w-5 h-5">
            <img src="/多边形 1.png" alt="" class="w-5 h-5">
            <img src="/多边形 1.png" alt="" class="w-5 h-5">
            <img src="/多边形 1.png" alt="" class="w-5 h-5">
            <img src="/多边形 1.png" alt="" class="w-5 h-5">

          </div>
          <div class="text-gray-400 text-sm pr-5">50000</div>
          <div class="flex justify-center mt-1">
            <el-rate v-model="overallRating" disabled size="small" :colors="['#22c55e', '#22c55e', '#22c55e']"
              class="rating-small" />
          </div>
        </div>
        <div class="flex-1 space-y-1 ml-4">
          <div v-for="rating in ratingDistribution" :key="rating.stars" class="flex items-center gap-2">
            <span class="text-xs text-gray-600 w-2">{{ rating.stars }}</span>
            <div class="flex-1 h-3 bg-gray-200 rounded-full overflow-hidden">
              <div class="h-full bg-blue-700 rounded-full transition-all duration-300"
                :style="{ width: rating.percentage }"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Reviews -->
      <div class="space-y-4">
        <div v-for="(review, index) in review2" :key="index" class="border-b border-gray-100 pb-4 last:border-b-0">
          <div class="flex items-center gap-2 mb-2 justify-between">
            <div class="flex items-center">
              <img :src="review.avatar" alt="" class="w-9">
              <span class="text-sm font-medium text-gray-900 mt-2.5 ml-3">{{ review.name }}</span>
            </div>


            <img class="w-1" src="/组 1053.png" alt="">
          </div>
          <div class="flex items-center gap-2 mb-2">
            <span class="text-xs text-gray-500">
              <img src="/多边形 1.png" alt="" class="w-3 h-3">
              <img src="/多边形 1.png" alt="" class="w-3 h-3">
              <img src="/多边形 1.png" alt="" class="w-3 h-3">
              <img src="/多边形 1.png" alt="" class="w-3 h-3">
              <img src="/多边形 1.png" alt="" class="w-3 h-3">
              <span class="ml-2">month.01 02, 2025</span>
            </span>
          </div>
          <p class="text-sm text-gray-700 leading-relaxed">{{ review.text }}</p>
          <div class="flex">
            <div class="text-gray-800 mt-1">Did you find this helpful?</div>
            <div class="w-15 h-7 text-center text-xl text-gray-600 ml-5"
              style="border: 1px solid #ccc;border-radius: 30px;">Yes</div>
            <div class="w-15 h-7 text-center text-xl text-gray-600 ml-2"
              style="border: 1px solid #ccc;border-radius: 30px;">No</div>
          </div>
        </div>
        <div class="text-blue-600 ml-2">View all reviews</div>
      </div>
      <!-- What's new -->
      <div class=" py-4 border-t mt-4">
        <div class="text-2xl">What's new</div>
        <div class="text-sm text-gray-600 mt-2">
          Hello fans, a new version has arrived! Here are some surprises for you!<br></br>
          - New game: CKC Game App Official<br></br>
          - New activity<br></br>
          - Bug fixed<br></br>
          Now it’s time to spin and win!
        </div>
      </div>
      <!-- Similar games -->
      <div class="flex items-center gap-2 mb-2 mt-4">
        <div class="text-gray-900 text-2xl flex">
          Similar games
          <img src="/向右.png" alt="" class="w-5 h-5 ml-42">
        </div>
      </div>
      <div v-for="item in similarS" :key="index" class="flex mt-12">
        <img class="w-15 h-15" :src="item.img" alt="">
        <div>
          <div class="text-gray-600 text-sm ml-3">{{ item.text1 }}</div>
          <div class="text-gray-600 text-sm ml-3 ">{{ item.text2 }}</div>
          <div class="text-gray-600 text-sm ml-3 flex">
            {{ item.nub }} <img class="w-4 h-4 ml-1 mt-0.5" src="/多边形 1 拷贝 5.png" alt="">
          </div>
        </div>
      </div>

    </div>
    <!-- Footer -->
    <div class="px-4 py-6 border-t text-xs text-gray-600 space-y-2 ">
      <div class="flex">
        <img class="h-5 ml-3" src="/图层 9.png" alt="">
        <div class="text-sm ml-6">Report as inappropriate</div>
      </div>
      <div class="text-sm h-12 text-center text-white border-gray-200 pt-4 mt-4 space-y-2 bg-blue-600"
        style="border-radius: 30px;">
        Download on the App Store
      </div>
      <div>
        <img class="h-1 w-85 mt-8" src="/矩形 1 拷贝 2.png" alt="">
      </div>
      <div>
        <div class="text-sm mt-5">App Store</div>
        <div class="flex mt-5">
          <img src="/pt-BR-Dsxg6v8e.png" alt="">

          <div class="text-sm ml-5">Philippines (Portuguese)</div>
        </div>
      </div>
    </div>
    <!--  -->

  </div>
  <!-- <div class="w-94 h-70 bg-white" style="position: fixed;bottom: 0;border-radius: 30px 30px 0 0;">
    <div class="ml-2 text-sm mt-5">Get the app on the App Store</div>
    <div class="w-110 h-60 ml-5 mt-5" style="background: url('/圆角矩形 4 拷贝.png') no-repeat; background-size: 75%;">
        <div class="flex">
            <img class="w-10 ml-6 mt-7" src="/blueGro.png" alt="">
            <div class="mt-7 ml-4">Suer Win Ph <br></br>Suer Win Ph.h21.com</div>
            <div></div>
        </div>
    </div>
  </div> -->

  <!-- iOS PWA 安装引导组件 -->
  <IosInstall v-model="showIosInstallGuide" :app-name="appData.name" :app-url="appUrl" :app-icon="'logo.png'"
    @close="handleIosInstallClose" />

  <van-popup v-model:show="show" teleport="body"
    :style="{ width: '80%', padding: '18px', 'background-color': '#fff', 'border-radius': '14px' }" :closeable="false"
    :close-on-click-overlay="false">
    <div>
      <div class="flex items-center gap-2 justify-center">
        <img src="@/assets/images/ic_raid_install.svg" alt="" width="28px">
        <span style="color: #202124;font-size: 28px;">Quick Installation</span>
      </div>
      <div class="text-center flex items-center justify-center my-4">
        <span style="color: #6F7276;border: 1px solid #707070;padding: 5px 30px; border-radius: 4px;">6 times
          faster</span>
      </div>
      <div class="flex items-center justify-center my-4">
        <div style="color: #6F7276;border: 1px solid #2B8661;padding: 2px 10px; border-radius: 50px;"
          class="text-center flex items-center justify-center">
          <img src="@/assets/images/ic_actived.svg" alt="" width="16px">
          <span style="color: #2B8661;font-size: 18px;">Activated</span>
        </div>
      </div>
      <div>
        <van-loading size="24px" vertical v-if="isLoading"><span style="color: #1B1B1B;font-size: 14px;">{{ percentage
        }}%</span></van-loading>
        <div v-else
          class="w-full mt-6 btn-color text-white font-medium py-3 rounded-lg transition-colors hover:bg-green-700 text-center"
          :class="{ 'opacity-60 cursor-not-allowed': isInstalling }" :style="{
            background: isInstalling
              ? `linear-gradient(90deg, #4CAF50 ${percentage}%, #70C944 ${percentage}%)`
              : undefined
          }" @click="handleInstall">
          <span v-if="!isInstalling">Install</span>
          <span v-else>{{ Math.round(percentage) }}%</span>
        </div>
      </div>
    </div>
  </van-popup>
  <ApkDownloadConfirm v-model:show="showApkDialog" />
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { getUrlParam, downloadAPK, getCookie, setCookie } from '@/utils/pub-use'
import IosInstall from '@/components/IosInstall/index.vue'
import ApkDownloadConfirm from '@/components/ApkDownloadConfirm/index.vue'
import { getPromotionAppByName } from '@/api/game'
import { initFacebookPixel } from '@/utils/facebook-pixel-tracking'
import { trackPwaInstallPromptShown, trackPwaInstallPromptConfirmed, trackPwaInstallPromptDismissed, trackPwaInstalled } from '@/utils/firebase-analytics'
import { getDeviceInfo, canInstallPWA, isPWAInstalled } from '@/utils/device'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/stores'
import ic_share from '@/assets/download/ic_share.png'
import ic_cloud_upload from '@/assets/download/ic_cloud_upload.png'
import yichu from '@/assets/download/yichu.png'
import ic_delete from '@/assets/download/ic_delete.png'
const ICON_BASE_URL = import.meta.env.VITE_IMG_URL
const router = useRouter()
const deviceInfo = getDeviceInfo()
const show = ref(false)
const showApkDialog = ref(false)
const appUrl = computed(() => {
  return window.location.hostname || 'Suer Win Ph.h21.com'
})
// 基于 datalists.type 来判断显示哪个版本，而不是基于设备类型
// 当 type 为 null 时，默认显示 Android 版本
const isAndroid = computed(() => datalists.value.type === 1 || datalists.value.type === null)

// 常量
const RESOURCE_BASE_URL = "/";

// 状态管理
const appRating = ref(5);
const overallRating = ref(5);
const isInstalling = ref(false)
const tabs = reactive([
  { name: "Games", active: false },
  { name: "Applications", active: true },
  { name: "Films", active: false },
  { name: "Books", active: false },
  { name: "Children", active: false },
]);

const similarS = reactive([
  { text1: "Cash Hoard Slots", text2: "Fantasy XClub", icon: "/多边形 1 拷贝 5.png", nub: "4.3", img: "/组 10.png" },
  { text1: "Winning Slots Las Vegas Casino", text2: "Triple Sevens: Casino Games", icon: "/多边形 1 拷贝 5.png", nub: "4.5", img: "/game2-Db3SJSfU.png" },
  { text1: "Slot 777 – Casino Games 888", text2: "Three Wishes Slot Machines Game Studio", icon: "/多边形 1 拷贝 5.png", nub: "4.8", img: "/game3-D86qLlQU.png" },
  { text1: "Grand Cash Casino Games", text2: "Gamehaus Network", icon: "/多边形 1 拷贝 5.png", nub: "4.9", img: "/game4-CYhpTDYj.png" },
  { text1: "Slots Casino – Jackpot Mania", text2: "SpinX Games Limited", icon: "/多边形 1 拷贝 5.png", nub: "4.7", img: "/game5-B5ZPUp6h.png" },
  { text1: "Cash Storm Slots Games", text2: "TRIWIN", icon: "/多边形 1 拷贝 5.png", nub: "4.7", img: "/game6-C2sdthJu.png" },
])

const screenshots = reactive([
  { gradient: "linear-gradient(135deg, #4ade80 0%, #3b82f6 100%)" },
  { gradient: "linear-gradient(135deg, #06b6d4 0%, #8b5cf6 100%)" },
  { gradient: "linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)" },
  { gradient: "linear-gradient(135deg, #10b981 0%, #3b82f6 100%)" },
]);

const gameTags = reactive(["Slot", "Casino", "Sports"]);

const dataSafetyItems = reactive([
  {
    icon: ic_share,
    text: "This app may share these types of data of data with third parties Location, financial information, device identifiers and other data may be shared with third",
  },
  {
    icon: ic_cloud_upload,
    text: "This app may collect these types of data Location, Personal information, and 5 more",
  },
  { icon: yichu },
  { icon: ic_delete, text: "You can request deletion of data" },
]);

const ratingDistribution = reactive([
  { stars: 5, percentage: "85%" },
  { stars: 4, percentage: "10%" },
  { stars: 3, percentage: "2%" },
  { stars: 2, percentage: "1%" },
  { stars: 1, percentage: "2%" },
]);

const reviews = reactive([
  {
    avatar: "/PedroHenriqueCosta.png",
    name: "Pedro Henrique Costa",
    rating: 5,
    date: "1 April 2024",
    text: "This is my favorite platform so far. There are many player-friendly offers on this platform! My favorite offer is a free bonus for inviting friends to play that only delight to play great games, but I also get rich as a result! So also claim different bonuses online every day!",
    helpful: 287,
  },
  {
    avatar: "/GabrielLima.png",
    name: "Gabriel Lima",
    rating: 5,
    date: "1 April 2024",
    text: "This is my favorite platform so far. There are many player-friendly offers on this platform! My favorite offer is a free bonus for inviting friends to play that only delight to play great games, but I also get rich as a result! So also claim different bonuses online every day!",
    helpful: 187,
  },
  {
    avatar: "/JooSilva.png",
    name: "João Silva",
    rating: 5,
    date: "1 April 2024",
    text: "This is my favorite platform so far. There are many player-friendly offers on this platform! My favorite offer is a free bonus for inviting friends to play that only delight to play great games, but I also get rich as a result! So also claim different bonuses online every day!",
    helpful: 87,
  },
]);

const review2 = reactive([
  {
    avatar: "/组 8.png",
    name: "Miguel",
    rating: 5,
    date: "March 7, 2024",
    text: "A very fun casual game, you can also earn moneyThis review was marked as helpful by 40 people 293",
    helpful: 287,
  },
  {
    avatar: "/组 9.png",
    name: "Jose",
    rating: 5,
    date: "January 5, 2024",
    text: "A very fun casual game, you can also earn moneyThis review was marked as helpful by 40 people 293",
    helpful: 187,
  },
]);

const similarGames = reactive([
  {
    name: "Avatar Game",
    initial: "A",
    color: "#f97316",
    rating: "4.8",
    ratingValue: 5,
    icon: "./static/te.png",
  },
  {
    name: "Turtle Game",
    initial: "A",
    color: "#ef4444",
    rating: "4.7",
    ratingValue: 5,
    icon: `${RESOURCE_BASE_URL}hash-indian/4b7baebd-4ed0-436d-ad3e-abefd4e7b8ce.png`,
  },
]);

const TabGanmes = reactive([
  { name: "Games", icon: "/游戏.png" },
  { name: "Apps", icon: "/组 1057.png" },
  { name: "Movies", icon: "/组 1056.png" },
  { name: "Music", icon: "/组 1058.png" },
  { name: "Kids", icon: "/多边形 54.png" },
])

const footerLink = reactive([
  "Terms of Service",
  "Privacy",
  "About Google Play",
  "Developers",
  "Google Store",
  "All prices include tax"
]);

const footerLinks = reactive([
  "Play Games",
  "Play Pass",
  "Play Points",
  "Gift cards",
  "Redeem",
  "Refund Policy"
]);


// 添加新的响应式变量
const showIosInstallGuide = ref(false)
const percentage = ref(0)
const isLoading = ref(true)

// 应用数据
const appData = ref({
  name: "Suer Win Ph",
  icon: "hash-indian/b9a028df-2b7c-4b82-a443-2d86a91c4997.png",
  score: 4.9,
  introduction: "",
  domainName: `${RESOURCE_BASE_URL}download/app-release.apk`,
  promotionalPicture: [],
});


// 检查 Facebook Pixel 状态的函数（可在控制台调用）
window.checkFacebookPixel = function () {
  try {
    const urlPixelId = getUrlParam("pixel")
    const cachedPixelId = getCookie('facebook_pixel_id')
    const defaultPixelId = window.DEFAULT_PIXEL_ID || null
    const pixelId = urlPixelId || cachedPixelId || defaultPixelId

    const isInitialized = !!(window.fbq && window.fbq.loaded)

    console.log('✅ Pixel ID:', pixelId || '未找到')
    console.log('   - URL参数:', urlPixelId || '无')
    console.log('   - 缓存值:', cachedPixelId || '无')
    console.log('   - 默认值:', defaultPixelId || '无')
    console.log('✅ 是否已初始化:', isInitialized ? '是' : '否')
    console.log('✅ fbq 对象:', window.fbq ? '存在' : '不存在')

    if (window.fbq) {
      console.log('✅ fbq.loaded:', window.fbq.loaded)
      console.log('✅ fbq.version:', window.fbq.version || '未知')
      console.log('✅ fbq.queue:', window.fbq.queue || [])
      console.log('✅ fbq.queue.length:', window.fbq.queue?.length || 0)
    } else {
      console.warn('⚠️ fbq 对象不存在，可能 SDK 还未加载')
    }

    // 检查网络请求
    const networkRequests = []
    if (performance && performance.getEntriesByType) {
      const entries = performance.getEntriesByType('resource')
      entries.forEach(entry => {
        if (entry.name && entry.name.includes('facebook.com/tr')) {
          networkRequests.push({
            url: entry.name,
            status: '成功',
            duration: Math.round(entry.duration) + 'ms'
          })
        }
      })
    }

    if (networkRequests.length > 0) {
      console.log('✅ 网络请求:', networkRequests)
    } else {
      console.log('⚠️ 未检测到上报请求，请检查：')
      console.log('   1. 打开浏览器开发者工具 -> Network 面板')
      console.log('   2. 筛选 "facebook.com" 或 "tr"')
      console.log('   3. 刷新页面查看是否有请求')
      console.log('   4. 安装 Facebook Pixel Helper 扩展进行验证')
    }

    console.groupEnd()

    return {
      pixelId,
      isInitialized,
      fbq: window.fbq,
      networkRequests
    }
  } catch (error) {
    console.error('检查 Facebook Pixel 状态时出错:', error)
    return null
  }
}

// 生命周期钩子
onMounted(async () => {
  // 初始化Lucide图标
  // lucide.createIcons();
  // 获取推广渠道数据
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    window.installPrompt = event
  })
  await getPromotionChannel();

  // 初始化 Facebook Pixel（与 index.html 一致，已包含 PageView 事件）
  await initFacebookPixel();

  window.$appsFlyerTracking?.trackLandingPageView()
  window.$adjustTracking?.trackLandingPageView()
});


const handleTagClick = (event) => {
  const tag = event.currentTarget;
  tag.classList.add("clicked");
};

const datalists = ref({})


// 获取推广渠道数据 - 使用项目封装的接口
const getPromotionChannel = async () => {
  // 优先使用URL参数中的channelName，如果没有则从cookie获取，最后使用接口返回的channelInfo.channelName
  let channelName = getUrlParam("channelName");

  // 如果URL中有channelName，存储到cookie
  if (channelName) {
    setCookie('channelName', channelName)
  } else {
    // 如果URL中没有，尝试从cookie获取
    channelName = getCookie('channelName')
  }

  // 获取channelId并存储到cookie
  let channelId = getUrlParam("channelId");
  if (channelId) {
    setCookie('channelId', channelId)
  } else {
    // 如果URL中没有，尝试从cookie获取
    channelId = getCookie('channelId')
  }

  // 如果URL和cookie都没有channelName，尝试从appStore中获取
  if (!channelName) {
    const appStore = useAppStore();
    // 如果appStore中还没有channelInfo，先获取域名信息
    if (!appStore.channelInfo) {
      try {
        await appStore.getDomainInfo();
      } catch (e) {
        console.error('获取域名信息失败:', e);
      }
    }
    // 使用接口返回的channelName，如果还是没有则使用默认值
    channelName = appStore.channelInfo?.channelName || "mainChannel";
  }

  const response = await getPromotionAppByName({ channelName });
  datalists.value = response.data
  console.log("🚀 ~ response:", datalists.value)
  console.log("🚀 ~ 使用的channelName:", channelName)
  console.log("🚀 ~ 使用的channelId:", channelId)
};

// iOS 安装引导关闭处理
const handleIosInstallClose = () => {
  showIosInstallGuide.value = false
  console.log('用户关闭了 iOS 安装引导')
}

const handleShow = async () => {
  // 上报 Facebook Pixel 安装点击事件（不管是谷歌还是苹果）
  await handleReport()
  // 如果是 App Store 类型 (type==2)，显示 iOS 安装引导
  if (datalists.value.type === 2) {
    console.log('App Store 类型，显示 iOS 安装引导')
    showIosInstallGuide.value = true
    return
  }

  // 从0增长到100%的下  载进度条效果
  const downloadTimer = setInterval(() => {
    const randomNum = Math.floor(Math.random() * 10 + 5) // 5-20的随机数
    if (percentage.value + randomNum >= 100) {
      percentage.value = 100
      clearInterval(downloadTimer)
      isLoading.value = false
    } else {
      percentage.value += randomNum
    }
  }, 300) // 每200ms更新一次进度
  show.value = true
}

const handleReport = async () => {
  // 检查并获取 pixelId
  const urlPixelId = getUrlParam("pixel")
  const cachedPixelId = getCookie('facebook_pixel_id')
  const defaultPixelId = window.DEFAULT_PIXEL_ID || null
  const pixelId = urlPixelId || cachedPixelId || defaultPixelId

  // 如果还没有初始化 Facebook Pixel 且有 pixelId，尝试初始化
  if (pixelId && (!window.fbq || !window.fbq.loaded)) {
    console.log('[安装按钮] 检测到 pixelId 但未初始化，重新初始化 Facebook Pixel')
    await initFacebookPixel()
  }

  // 上报点击安装按钮埋点，使用 trackSingle 显式传递 pixelId（从 URL 参数 pixel 获取）
  if (typeof window.fbq === 'function') {
    if (pixelId) {
      // 使用 trackSingle 方法，显式传递 pixelId，确保使用 URL 中的 pixel
      window.fbq('trackSingle', pixelId, 'Install')
      console.log('[安装按钮] Facebook Pixel Install 事件已上报，pixelId:', pixelId, '来源: URL参数')
    } else {
      // 如果没有 pixelId，使用标准的 track 方法
      window.fbq('track', 'Install')
      console.log('[安装按钮] Facebook Pixel Install 事件已上报（使用已初始化的 pixelId）')
    }
  } else {
    console.warn('[安装按钮] Facebook Pixel 未初始化，无法上报 Install 事件')
  }
  window.$appsFlyerTracking?.trackLandingPageInstall()
  window.$adjustTracking?.trackLandingPageInstall()
}

const startTimer = () => {
  return new Promise((resolve, reject) => {
    percentage.value = 0
    const installTimer = setInterval(() => {
      const randomNum = Math.floor(Math.random() * 15 + 5) // 5-20的随机数
      if (percentage.value + randomNum >= 100) {
        percentage.value = 100
        clearInterval(installTimer)
        resolve()
      } else {
        percentage.value += randomNum
      }
    }, 200) // 每200ms更新一次进度
  })
}

// 修改安装应用函数
const handleInstall = async () => {
  handleReport()
  // 如果是iOS设备，弹出引导安装组件
  if (deviceInfo.isIOS) {
    console.log('iOS设备，显示安装引导')
    showIosInstallGuide.value = true
    return
  }
  // 2. 判断是否支持PWA安装
  if (!canInstallPWA()) {
    console.log('不支持PWA安装，下载APK')
    isInstalling.value = true
    await downloadAPK()
    return
  }

  // 3. 如果是Android设备，处理PWA安装
  // 或者桌面端
  if (deviceInfo.isAndroid || !deviceInfo.isMobile) {
    console.log('Android/PC设备，处理PWA安装')
    const installPrompt = window.installPrompt
    if (!installPrompt) {
      console.log('没有安装提示，下载APK')
      isInstalling.value = true
      await startTimer()
      downloadAPK()
      isInstalling.value = false
      return
    }
    trackPwaInstallPromptShown()
    try {
      const { outcome } = await installPrompt.prompt()

      if (outcome === 'accepted') {
        trackPwaInstallPromptConfirmed()
        // 这里是模拟的安装进度
        // 用户确认安装后，开始显示进度条
        isInstalling.value = true
        // 从0增长到100%的安装进度条效果
        await startTimer()

        isInstalling.value = false
        if (isPWAInstalled()) {
          // 导航到主页
          router.push('/')
        }
      } else if (outcome === 'dismissed') {
        console.log('用户取消安装，显示APK下载弹框')
        // 显示APK下载确认弹窗
        showApkDialog.value = true
        trackPwaInstallPromptDismissed()
      }

    } catch (error) {
      console.error('安装过程出错:', error)
      // 重置状态并下载APK
      isLoading.value = false
      percentage.value = 0
      await downloadAPK()
    }

    return
  }

  isInstalling.value = true
  console.log('开始安装流程')


  // 如果是iOS设备，弹出引导安装组件
  if (deviceInfo.isIOS) {
    console.log('iOS设备，显示安装引导')
    showIosInstallGuide.value = true
    return
  }

  const downloadTimer = setInterval(() => {
    const randomNum = Math.floor(Math.random() * 15 + 5) // 5-20的随机数
    if (percentage.value + randomNum >= 100) {
      percentage.value = 100
      clearInterval(downloadTimer)
      isLoading.value = false
    } else {
      percentage.value += randomNum
    }
  }, 200) // 每200ms更新一次进度
  // 其他设备（Android、PC等）显示loading效果后下载APK
  percentage.value = 0
}
</script>

<style scoped>
/* Element Plus 组件自定义样式 */
.active {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);

}

.loading {
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
}

.el-rate {
  height: auto !important;
  line-height: 1 !important;
}

.rating-small .el-rate__item {
  font-size: 12px !important;
  margin-right: 2px !important;
}

.rating-tiny .el-rate__item {
  font-size: 10px !important;
  margin-right: 1px !important;
}

.el-tag--small {
  height: 24px !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  border-radius: 4px !important;
}

.el-button--small {
  height: 24px !important;
  padding: 0 8px !important;
  font-size: 12px !important;
}

/* 自定义滚动条 */
.overflow-x-auto::-webkit-scrollbar {
  height: 4px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 安装按钮进度条样式 */
.install-btn-loading {
  transition: all 0.3s ease;
}

.install-btn-loading:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 平滑过渡 */
* {
  transition: all 0.2s ease;
}

/* 分享按钮点击效果 */
.share-button {
  padding: 6px 4px !important;
}

.share-button:active {
  background-color: #b8d4f2 !important;
}

.share-button.clicked {
  background-color: #e3eefc !important;
}

/* 标签点击效果 */
.clickable-tag {
  cursor: pointer;
}

.clickable-tag:active {
  background-color: #b8d4f2 !important;
}

.clickable-tag.clicked {
  background-color: #e3eefc !important;
}

/* 模态框动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

[v-cloak] {
  display: none;
}

.btn-color {
  background-color: #01875F;
}
</style>
